import { JobsStatusConstants } from '../../api';

// PRICE_REQUEST, DEFECTING, PRICE_SUBMITTED and PARTNER_DECLINED are excluded on purpose: they are read-only in the legacy admin (story 7966).
export const FILE_EDIT_STATUSES = [
    JobsStatusConstants.APPROVED,
    JobsStatusConstants.INPROGRESS,
    JobsStatusConstants.NEW,
    JobsStatusConstants.PAUSED,
    JobsStatusConstants.PREORDER,
    JobsStatusConstants.UNKNOWN,
    JobsStatusConstants.WAITING_FOR_APPROVAL,
    JobsStatusConstants.PAID,
    JobsStatusConstants.RESOLVED,
    JobsStatusConstants.COMPLETED
];
